module.exports = {"id":"237556","name":"Christian Luyindama","rating":"73","photo":"./data/images/photos/2/237556.png","club":{"name":"Standard Liège","logo":"./data/images/clubs/StandardLiege.png"},"positions":["DC","MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChristianLuyindama0.json
// module id = 794
// module chunks = 0